if (!customElements.get('product-highlights')) {
  customElements.define(
    'product-highlights',
    class ProductHighlights extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.button = this.querySelector('.product-highlights__toggle');
        this.list = this.querySelector('.product-highlights__content > ul, .product-highlights__content > ol');
        this.collapsedItems = Math.min(Math.max(parseInt(this.dataset.collapsedItems, 10) || 3, 1), 10);

        if (!this.button || !this.list) return;

        const listItems = Array.from(this.list.children).filter((item) => item.tagName === 'LI');

        if (listItems.length <= this.collapsedItems) {
          this.button.hidden = true;
          return;
        }

        this.button.hidden = false;
        this.button.addEventListener('click', () => this.toggleHighlights());
      }

      toggleHighlights() {
        const isExpanded = this.classList.toggle('is-expanded');

        this.button.setAttribute('aria-expanded', isExpanded.toString());
      }
    }
  );
}
